<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="450px"
			center
			:append-to-body='true'
			@close="openWin(false,'')"
			:visible.sync="gradeWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					评级
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<div class="userinfo">
					<div>党员：{{u_name}}</div>
					<div>年度：{{year}}</div>
				</div>
				<div class="grade_wrap">
					<div class="grade_item"
					 @click="formData.level = 4"
					 :class="{selectGrade:formData.level == 4}">优秀</div>
					<div class="grade_item"
					 @click="formData.level = 3"
					 :class="{selectGrade:formData.level == 3}">合格</div>
					<div class="grade_item"
					 @click="formData.level = 2"
					 :class="{selectGrade:formData.level == 2}">基本合格</div>
					<div class="grade_item"
					 @click="formData.level = 1"
					 :class="{selectGrade:formData.level == 1}">不合格</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">确定</el-button>
				<el-button @click="openWin(false,'')">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { zzsh } from '@/axios'
	let that;
	export default{
		data(){
			return{
				formData:{
					uid:'',
					year:"",
					level:"",
				},
				u_name:'',
				gradeWin:false
			}
		},
		props:{
			year:{
				type:Number,
				default:new Date().getFullYear()
			}
		},
		created() {
			that = this;
		},
		methods:{
			// 打开弹窗
			openWin(type,data){
				that.gradeWin = type;
				if(type){
					// 打开弹窗
					that.formData.uid = data.id;
					that.u_name = data.u_name;
					that.formData.year = that.year;
					if(!data.level){
						// 未评级
					}else{
						// 已经评级
						that.formData.level = data.level;
					}
				}else{
					that.clearForm();
				}
			},
			// 清空表单
			clearForm(){
				that.formData = {
					uid:'',
					year:"",
					level:""
				};
				that.u_name = ""
			},
			// 提交表单
			submit(){
				if(that.formData.level){
					zzsh.appraiseAudit(that.formData).then(res => {
						if(res.code == 200){
							that.openWin(false,'')
							that.$emit('dataList')
						}else{
							Message.error(res.msg);
						}
					})
				}else{
					Message.warning('请选择等级')
				}
			},
			// 清除表单
			closeGradeWin(){
				that.$emit('closeGradeWin');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.userinfo{
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		color: rgba(112, 112, 112, 1);
		margin-bottom: 40px;
	}
	.grade_wrap{
		display: flex;
		flex-wrap: wrap;
		.grade_item{
			cursor: pointer;
			margin-top: 20px;
			margin-right: 36px;
			font-size: 16px;
			text-align: center;
			line-height: 40px;
			width: 180px;
			height: 40px;
			border: 1px solid rgb(166, 166, 166);
			border-radius: 4px;
		}
		.grade_item:nth-child(2n){
			margin-right: 0 !important;
		}
		.grade_item:hover{
			background: #BB0000;
			color: #fff;
			border: 1px solid #BB0000;
		}
		.selectGrade{
			background: #BB0000;
			color: #fff;
			border: 1px solid #BB0000;
		}
	}
</style>
